import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
/* eslint-disable */
@Injectable({
  providedIn: 'root',
})
export class CloudReadinessAssessmentService {
  questionsAnswers: any = {};
  constructor(
    private apiService: ApiService
  ) {}

  getCloudReadinessAssessmentPublicQuestions() {
    return this.apiService.get('cloud-readiness/public/pages');
  }

  saveCloudAssessmentAnswers(payload) {
    return this.apiService.post('cloud-readiness/public/submit', payload);
  }

  getPublicCloudReadinessReport(tokenId: string) {
    return this.apiService.get(
      '/cloud-readiness/public/reports?token=' + tokenId
    );
  }
}
